import { ENVIRONMENT } from './../environments/environment';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PushNotificationUseCase } from './application/usesCases/push-notification/pushNotification.service';
//type
import { WebCompontensArray } from './domain/models/webComponentesArray';
//list elements
import { webComponents } from './importComponetns';
import { FetchUserAttributesUsecase } from './auth/application/usecases/fetch-user-attributes/fetch-user-attributes.usecase';
import { take } from 'rxjs';

@Component({
  selector: 'app-root',
  template: `
    <app-spinner></app-spinner>
    <router-outlet></router-outlet>
  `,
})
export class AppComponent implements OnInit{

  constructor(private translate: TranslateService,private pushNotification: PushNotificationUseCase, private fetchUserAttributesUsecase: FetchUserAttributesUsecase) {
    this.i18ninit();
    this.devCustomComponents();
  }

  i18ninit() {
    const languaje: string = localStorage.getItem('lealLenguaje') || 'default';
    this.translate.use(languaje);
  }

  ngOnInit(): void {
    this.pushNotification.requestPermission()
    this.loadClarityScript();
    this.initializeMsClarity();
  }

  /**
   *Create conection with stencil via a script tag, this function only works in local
   @author Sebastian C
   */
  private devCustomComponents() {
    if (!ENVIRONMENT.useDesignsystem) {
      const url = `${ENVIRONMENT.urls.lealCustomComponents}.js`;
      const urlEsm = `${ENVIRONMENT.urls.lealCustomComponents}.esm.js`;
      let elementUrl = document.querySelector(`script[src="${url}"]`);
      let elementUrlEsm = document.querySelector(`script[src="${urlEsm}"]`);
      if (!elementUrl) {
        elementUrl = document.createElement('script');
        elementUrl.setAttribute('src', url);
        elementUrl.setAttribute('nomodule', '');
        document.head.appendChild(elementUrl);
      }
      if (!elementUrlEsm) {
        elementUrl = document.createElement('script');
        elementUrl.setAttribute('src', urlEsm);
        elementUrl.setAttribute('type', 'module');
        document.head.appendChild(elementUrl);
      }
      this.createWebCompontensLocal(webComponents)
    }
  }

  private createWebCompontensLocal(webcompontens:WebCompontensArray[]){
    webcompontens.forEach(webComp =>{
      customElements.whenDefined(webComp.name).then(res=>{
        customElements.define(`shell-${webComp.name}`, class extends res {})
      })
    })
  }

  /**
   *  inject the script tag in the head of the document to load the clarity script (Microsoft clarity)
   *  with the environment variable for QA and PDN
   */

  loadClarityScript() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.innerHTML = `
      (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "${ENVIRONMENT.clarityProjectId}");`;
    document.head.appendChild(script);
  }

  initializeMsClarity(){

    if (typeof clarity !== 'undefined') {
      this.fetchUserAttributesUsecase
      .execute()
      .pipe(take(1))
      .subscribe((user) => {
        clarity("set" , "inicio", `idCommerce: ${user.idCommerce} - Role: ${user.idRole}`);
      });
    }

  }
}
